/* eslint-disable max-lines */
import { message as $message } from 'antd'
import {
    getUserMenuPermission,
    queryHidedMenuList,
    getUserMenus,
    queryUserMenuWhiteList
} from '@/services/permissionMenu'
import { queryBindShopApi, queryShopInfoTotal, queryPlatformBanKeywords } from '@/services/myGoods'
import { queryAppShelvesGuideWhiteListUsingGET1 } from '@/services/goods'
import { getBigShopCoIdList } from '@/services/freshman'
import { getContractVersion } from '@/services/login'
import { history } from 'umi'
import { PLATFORM_INFO_LIST, filterShopTypeListByPlatformType } from '@/modules/globals/constants/platform/basics'
import { isZongHengApp, fullAppCode } from '@/utils/singleApp'
import { captureMessage } from '@/utils/track'

import {
    ERP_AFTERSALE_BIGSHOP_AUTO,
    COMMISSION_SUPPORT_GOODS_SKU,
    NEW_AFTER_SALES_ISSUE_REGISTRATION_WHITELIST,
    REFUND_ONLY_ORDER_STATUS_WHITELIST,
    ALLOW_NEGATIVE_DEDUCTION_WHITE_LIST,
    DY_GOODS_SIZE_VALIDATE_WHITE_LIST,
    AFTERSALE_AUTO_RETURN_ADDRESS_NEW,
    SUPPLIER_RETURN_ADDRESS_MAINTAIN_WHITELIST,
    AFTER_SALE_ADDRESS_MIDDLEMAN,
    AFTER_SALE_SCM_INTERCEPT_LOGISTICS,
    TAO_SHOPPING_TITLE_MERGE_WHITE_LIST,
    SUP_DIS_COMBINATION_PACKAGE_SELLER_COMPENSATION_WHITELIST,
    AFTERSALE_SUPPLIER_REISSUE_WHITE_LIST,
    ONLINE_REFUND_WITHDRAWAL_WHITELIST,
    AFTER_SALE_ADDRESS_COMPARISON_WHITE_LIST,
    ORDER_JD_DECRYPTION_WHITELIST,
    AFTER_SALE_PDD_AUTO_REFUNDONLY_WHITE_LIST,
    AFTERSALE_NEGOTIATION_ENABLE_WHITELIST,
    ASF_AUTO_BIND_SAMPLE_ORDER,
    DRP_ALLOW_FUND_NEGATIVE,
    AFTER_SALES_RETURN_ASYNC_WHITELIST,
    SEARCH_STOCK_BLOCK,
    DOU_YIN_SPU_MANAGE,
    EXPRESS_INTERCEPTION_OLD_VERSION_WHITELIST,
    SMALL_PAY_WHITE_LIST,
    AFTER_SALE_SUP_DEDUCTION_RULE,
    CONFIRM_RECEIPT_EXCLUDE_GIFT_WHITELIST,
    DRP_RULE_MERGE,
    EXPORT_MULTI_COMPANY,
    GOODS_RULE_OPERATE_V2,
    SHOW_CURRENT_ARREARS_COIDS,
    ORDER_EXCHANGE_GOODS_WHITE_LIST,
    GOODS_DRAFT_STATUS,
    PRINTER_CLOSE_WHITE_LIST,
    PRINTER_CLOSE_PROMT_WHITE_LIST,
    ORDER_DRP_ZPLAN_SETLC_REFREIGHT,
    ACCESS_PRE,
    DRP_ORDER_PUSH_AUTO_SPLIT_COMBINE,
    GOODS_WECHAT_NOTIFY_COID,
    INSIDER_COID_LIST,
    ASYNC_AUDIT_ORDER_WHITE_LIST,
    DAREN_BELONG_AUTO_RELEASE_WHITELIST,
    HOT_GOODS_PRIVILEGE,
    AFTER_SALE_IPC_OPEN_V2,
    AFTER_SALE_IPC_OPEN_MERGE,
    ORDER_GUIDE_WHITELIST_MASTER_SLAVE,
    PURCHASE_AMOUNT_SHARDING_WHITELIST,
    PENDING_ORDERS_BY_SUPPLIER_COUNT,
    CHANNEL_CUSTOMER_CENTER_DIY_DATE,
    PAY_REFUND_ONLINE_SUFFIX_WHITELIST,
    UNDERPRICED_ORDER_WHITELIST,
    GOODS_POOL_WEIGHT_DETAILS_WHITE_LIST,
    SUPPLIER_AUTO_REFUND,
    AFTER_AUTO_SALE_INTERCEPT_LOGISTICS,
    AFTERSALE_EXCHANGE_AUTO_CONFIRM_WHITELIST,
    FREE_SUPPLIER_FORBID_RECHARGE_SYSTEM_NOTICE_WHITE_LIST,
    BATCH_UPDATE_DIS_PRICE_WHITE_LIST,
    MIN_PURCHASE_COIDS,
    PUSH_ORDER_COMMERCIALIZE_WHITELIST,
    PC_SHELVES_DY_FAST_PERFECT_TEMPLATE,
    FORECAST_PLATFORM_WHITE_LIST,
    DY_NEW_CATEGORY_EDIT_AND_FORCED_CONTROL,
    DY_ALLOW_MODIFY_CATEGORY,
    UPLOAD_SHOP_RETURN_ADDRESS_WHEN_STOCKING_WHITELIST,
    DRP_SEND_UPLOAD_AFS_ADDRESS,
    GOODS_RULE_OPERATE_SKU_REPLENISHMENT,
    DOUYIN_TIME_SALE_STOCK,
    ORDER_SYNC_ONLINE_DELIVERY_FAIL_WHITE,
    ORDER_SYNC_ONLINE_DELIVERY_FAIL_BLACK,
    POLICY_CHANNEL_LABEL_WHITE_LIST,
    PUSH_ORDER_FORBID_EDIT_AMOUNT,
    PRINTER_INOUT_LIST_5000_WHITELIST,
    AUTONOMY_SYNC_PLATFORM_CATE_WHITE,
    FIND_DAREN_WHITELIST,
    SHOP_PUBLISH_WHITELIST,
    CUSTOMER_CHAT_NEW_VERSION,
    KS_SHELVES_SUPPORT_VIDEO,
    FORCAST_CATEGORY_WITH_IMAGE,
    USE_SYSTEM_FORCAST_CATEGORY,
    ORDER_DRP_PRIORITY_FILTERRULE,
    DRP_SUPPLIER_SYNC_STOCK_WHITELIST,
    PRINTER_SENSITIVE_WHITELIST,
    PRINTER_SUPPORT_SUB_BILL_WHITELIST,
    PARTNER_SPU_SHOP_LINK_WHITE_LIST,
    TAO_GOODS_SHELVES_TAO_PLATFORM,
    DAREN_IMPROT_ERP_ORDER_TO_SAMPLE
} from '@/modules/globals/constants/queryWhiteKey'
import { cacheRequestWrap } from '@/utils/requestUtils'
import { delay } from '@/utils/utils'

const transBlackList = data => {
    if (Array.isArray(data)) {
        return data.reduce((t, c) => {
            return t.concat(c.split(','))
        }, [])
    }

    return []
}

// 渠道及供应侧 菜单权限
export default {
    namespace: 'menu',
    state: {
        menus: [],
        userMenus: [],
        showMenuTip: [], // 需要动态控制菜单显示tip的menuKey
        shopIdList: {}, // 返回对象 {Alibaba: "11899158"}
        shopInfoTotal: [], // 可以选择的平台下店铺的数量
        platformBanKeywords: {}, // 平台禁用词
        // 菜单黑名单，本来是放在layout里面自己调用，由于支付也需要判断，所以放到全局
        blackMenuList: [],
        // 大店的coid 是个数组，但是目前只有一个
        bigShopCoIdList: [],
        updateBigShopCoIdListFetching: false, // 用于避免接口重复请求
        blackMenuListMounted: false,
        userMenuWhiteList: {
            GOODS_RULE_OPERATE_V2: false,
            DOU_YIN_SPU_MANAGE: false,
            EXPRESS_INTERCEPTION_OLD_VERSION_WHITELIST: false,
            SMALL_PAY_WHITE_LIST: false,
            SEARCH_STOCK_BLOCK: false, // 只看有货 黑名单
            AFTER_SALE_SUP_DEDUCTION_RULE: false,
            ASF_AUTO_BIND_SAMPLE_ORDER: false,
            DRP_RULE_MERGE: false,
            ERP_AFTERSALE_BIGSHOP_AUTO: false,
            NEW_AFTER_SALES_ISSUE_REGISTRATION_WHITELIST: false,
            REFUND_ONLY_ORDER_STATUS_WHITELIST: false,
            ALLOW_NEGATIVE_DEDUCTION_WHITE_LIST: false,
            DY_GOODS_SIZE_VALIDATE_WHITE_LIST: false,
            AFTER_SALE_PDD_AUTO_REFUNDONLY_WHITE_LIST: false,
            DRP_ALLOW_FUND_NEGATIVE: false,
            AFTERSALE_AUTO_RETURN_ADDRESS_NEW: false,
            SUPPLIER_RETURN_ADDRESS_MAINTAIN_WHITELIST: false,
            AFTER_SALE_ADDRESS_MIDDLEMAN: false,
            AFTER_SALE_SCM_INTERCEPT_LOGISTICS: false,
            TAO_SHOPPING_TITLE_MERGE_WHITE_LIST: false,
            EXPORT_MULTI_COMPANY: false,
            AFTERSALE_SUPPLIER_REISSUE_WHITE_LIST: false,
            COMMISSION_SUPPORT_GOODS_SKU: false,
            SUP_DIS_COMBINATION_PACKAGE_SELLER_COMPENSATION_WHITELIST: false,
            ONLINE_REFUND_WITHDRAWAL_WHITELIST: false,
            AFTER_RETURN_ADDRESS_EXCEPTION: false,
            AFTER_SALE_ADDRESS_COMPARISON_WHITE_LIST: false,
            AFTER_SALES_RETURN_ASYNC_WHITELIST: false,
            ORDER_JD_DECRYPTION_WHITELIST: false,
            AFTERSALE_NEGOTIATION_ENABLE_WHITELIST: false,
            PUSH_ORDER_COMMERCIALIZE_WHITELIST: false,
            PC_SHELVES_DY_FAST_PERFECT_TEMPLATE: false,
            FORECAST_PLATFORM_WHITE_LIST: false,
            DY_NEW_CATEGORY_EDIT_AND_FORCED_CONTROL: false,
            DY_ALLOW_MODIFY_CATEGORY: false,
            UPLOAD_SHOP_RETURN_ADDRESS_WHEN_STOCKING_WHITELIST: false,
            DRP_SEND_UPLOAD_AFS_ADDRESS: false,
            ACCESS_PRE: true, // 默认给true， 如果false了再跳转吧
            DRP_ORDER_PUSH_AUTO_SPLIT_COMBINE: false,
            SHOW_CURRENT_ARREARS_COIDS: false,
            PAY_REFUND_ONLINE_SUFFIX_WHITELIST: false,
            GOODS_DRAFT_STATUS: false,
            ORDER_EXCHANGE_GOODS_WHITE_LIST: false,
            GOODS_WECHAT_NOTIFY_COID: false,
            ASYNC_AUDIT_ORDER_WHITE_LIST: false,
            DAREN_BELONG_AUTO_RELEASE_WHITELIST: false,
            ORDER_SYNC_ONLINE_DELIVERY_FAIL_WHITE_LIST: false,
            ORDER_DRP_ZPLAN_SETLC_REFREIGHT: false,
            INSIDER_COID_LIST: false,
            CHANNEL_CUSTOMER_CENTER_DIY_DATE: false,
            HOT_GOODS_PRIVILEGE: false,
            FIND_DAREN_WHITELIST: false,
            PENDING_ORDERS_BY_SUPPLIER_COUNT: false,
            AFTER_SALE_IPC_OPEN_V2: false,
            AFTER_SALE_IPC_OPEN_MERGE: false,
            UNDERPRICED_ORDER_WHITELIST: false,
            GOODS_POOL_WEIGHT_DETAILS_WHITE_LIST: false,
            SUPPLIER_AUTO_REFUND: false,
            AFTER_AUTO_SALE_INTERCEPT_LOGISTICS: false,
            AFTERSALE_EXCHANGE_AUTO_CONFIRM_WHITELIST: false,
            BATCH_UPDATE_DIS_PRICE_WHITE_LIST: false,
            MIN_PURCHASE_COIDS: false,
            GOODS_RULE_OPERATE_SKU_REPLENISHMENT: false,
            DOUYIN_TIME_SALE_STOCK: false,
            PRINTER_CLOSE_PROMT_WHITE_LIST: false,
            POLICY_CHANNEL_LABEL_WHITE_LIST: false,
            PRINTER_CLOSE_WHITE_LIST: false,
            PUSH_ORDER_FORBID_EDIT_AMOUNT: false,
            PRINTER_INOUT_LIST_5000_WHITELIST: false,
            AUTONOMY_SYNC_PLATFORM_CATE_WHITE: false,
            SHOP_PUBLISH_WHITELIST: false,
            CUSTOMER_CHAT_NEW_VERSION: false,
            KS_SHELVES_SUPPORT_VIDEO: false,
            FORCAST_CATEGORY_WITH_IMAGE: false,
            USE_SYSTEM_FORCAST_CATEGORY: false,
            ORDER_DRP_PRIORITY_FILTERRULE: false,
            DRP_SUPPLIER_SYNC_STOCK_WHITELIST: false,
            PRINTER_SENSITIVE_WHITELIST: false,
            PRINTER_SUPPORT_SUB_BILL_WHITELIST: false,
            PARTNER_SPU_SHOP_LINK_WHITE_LIST: false,
            TAO_GOODS_SHELVES_TAO_PLATFORM: false,
            DAREN_IMPROT_ERP_ORDER_TO_SAMPLE: false
        },
        appShelvesGuideWhiteList: [], // 抖音小程序上架引导
        userMenuWhiteListInited: false // 白名单接口是否请求结束
    },
    effects: {
        *queryAppShelvesGuideWhiteList(_, { call, put }) {
            try {
                const response = yield call(queryAppShelvesGuideWhiteListUsingGET1)

                if (response) {
                    const { success, message, data } = response
                    if (success) {
                        yield put({
                            type: 'update',
                            payload: {
                                appShelvesGuideWhiteList: data
                            }
                        })
                    } else {
                        $message.error(message)
                    }
                }
            } catch (error) {
                // 404 抛出 error 对象被外面的 try catch 拿到..
                console.error('REJECT_queryAppShelvesGuideWhiteList', error)
            }
        },
        *queryBigShopCoIdList(_, { call, put, select }) {
            // 检查是否已经获取过列表
            const updateBigShopCoIdListFetching = yield select(state => state.menu.updateBigShopCoIdListFetching)

            const currentBigShopCoIdList = yield select(state => state.menu.bigShopCoIdList)
            if (currentBigShopCoIdList?.length > 0) return currentBigShopCoIdList // 如果已经获取过，则直接返回当前列表数据

            if (updateBigShopCoIdListFetching) {
                // 如果正在获取列表，则等待
                yield delay(100) // 每 100ms 检查一次
                return yield put({ type: 'queryBigShopCoIdList' })
            }

            yield put({
                type: 'updateBigShopCoIdListFetching',
                payload: true
            })
            try {
                // 发起请求获取大店 COID 列表

                const response = yield call(getBigShopCoIdList)
                if (response.success) {
                    // 请求成功，更新 state
                    yield put({
                        type: 'updateBigShopCoIdList',
                        payload: response.data
                    })
                    yield put({
                        type: 'updateBigShopCoIdListFetching',
                        payload: false
                    })
                    return response.data
                } else {
                    $message.error(response.message)
                }
            } catch (error) {
                console.error('queryBigShopCoIdList error', error)
            }
        },

        *queryUserMenuWhiteList(_, { call, put, select }) {
            // eslint-disable-next-line jst-gyl/disable-empty-catch
            try {
                const { success, message, data } = yield call(
                    cacheRequestWrap(queryUserMenuWhiteList, 'queryUserMenuWhiteList'),
                    {
                        keyList: [
                            DOU_YIN_SPU_MANAGE,
                            EXPRESS_INTERCEPTION_OLD_VERSION_WHITELIST,
                            SMALL_PAY_WHITE_LIST,
                            SEARCH_STOCK_BLOCK,
                            DRP_RULE_MERGE,
                            ERP_AFTERSALE_BIGSHOP_AUTO,
                            NEW_AFTER_SALES_ISSUE_REGISTRATION_WHITELIST,
                            REFUND_ONLY_ORDER_STATUS_WHITELIST,
                            ALLOW_NEGATIVE_DEDUCTION_WHITE_LIST,
                            DY_GOODS_SIZE_VALIDATE_WHITE_LIST,
                            AFTERSALE_AUTO_RETURN_ADDRESS_NEW,
                            SUPPLIER_RETURN_ADDRESS_MAINTAIN_WHITELIST,
                            AFTER_SALE_ADDRESS_MIDDLEMAN,
                            AFTER_SALE_SCM_INTERCEPT_LOGISTICS,
                            TAO_SHOPPING_TITLE_MERGE_WHITE_LIST,
                            AFTERSALE_SUPPLIER_REISSUE_WHITE_LIST,
                            ASF_AUTO_BIND_SAMPLE_ORDER,
                            SUP_DIS_COMBINATION_PACKAGE_SELLER_COMPENSATION_WHITELIST,
                            ONLINE_REFUND_WITHDRAWAL_WHITELIST,
                            AFTER_SALE_ADDRESS_COMPARISON_WHITE_LIST,
                            EXPORT_MULTI_COMPANY,
                            ORDER_EXCHANGE_GOODS_WHITE_LIST,
                            AFTER_SALE_PDD_AUTO_REFUNDONLY_WHITE_LIST,
                            DRP_ALLOW_FUND_NEGATIVE,
                            ORDER_JD_DECRYPTION_WHITELIST,
                            AFTERSALE_NEGOTIATION_ENABLE_WHITELIST,
                            AFTER_SALES_RETURN_ASYNC_WHITELIST,
                            CONFIRM_RECEIPT_EXCLUDE_GIFT_WHITELIST,
                            GOODS_RULE_OPERATE_V2,
                            ACCESS_PRE,
                            DRP_ORDER_PUSH_AUTO_SPLIT_COMBINE,
                            ORDER_DRP_ZPLAN_SETLC_REFREIGHT,
                            AFTER_SALE_SUP_DEDUCTION_RULE,
                            SHOW_CURRENT_ARREARS_COIDS,
                            GOODS_DRAFT_STATUS,
                            GOODS_WECHAT_NOTIFY_COID,
                            ASYNC_AUDIT_ORDER_WHITE_LIST,
                            DAREN_BELONG_AUTO_RELEASE_WHITELIST,
                            AFTER_SALE_IPC_OPEN_V2,
                            AFTER_SALE_IPC_OPEN_MERGE,
                            INSIDER_COID_LIST,
                            HOT_GOODS_PRIVILEGE,
                            ORDER_GUIDE_WHITELIST_MASTER_SLAVE,
                            PUSH_ORDER_COMMERCIALIZE_WHITELIST,
                            FIND_DAREN_WHITELIST,
                            PC_SHELVES_DY_FAST_PERFECT_TEMPLATE,
                            PRINTER_CLOSE_WHITE_LIST,
                            PRINTER_CLOSE_PROMT_WHITE_LIST,
                            FORECAST_PLATFORM_WHITE_LIST,
                            DY_NEW_CATEGORY_EDIT_AND_FORCED_CONTROL,
                            DY_ALLOW_MODIFY_CATEGORY,
                            UPLOAD_SHOP_RETURN_ADDRESS_WHEN_STOCKING_WHITELIST,
                            DRP_SEND_UPLOAD_AFS_ADDRESS,
                            PURCHASE_AMOUNT_SHARDING_WHITELIST,
                            COMMISSION_SUPPORT_GOODS_SKU,
                            PENDING_ORDERS_BY_SUPPLIER_COUNT,
                            PAY_REFUND_ONLINE_SUFFIX_WHITELIST,
                            CHANNEL_CUSTOMER_CENTER_DIY_DATE,
                            UNDERPRICED_ORDER_WHITELIST,
                            GOODS_POOL_WEIGHT_DETAILS_WHITE_LIST,
                            SUPPLIER_AUTO_REFUND,
                            AFTER_AUTO_SALE_INTERCEPT_LOGISTICS,
                            AFTERSALE_EXCHANGE_AUTO_CONFIRM_WHITELIST,
                            FREE_SUPPLIER_FORBID_RECHARGE_SYSTEM_NOTICE_WHITE_LIST,
                            BATCH_UPDATE_DIS_PRICE_WHITE_LIST,
                            MIN_PURCHASE_COIDS,
                            GOODS_RULE_OPERATE_SKU_REPLENISHMENT,
                            DOUYIN_TIME_SALE_STOCK,
                            POLICY_CHANNEL_LABEL_WHITE_LIST,
                            ORDER_SYNC_ONLINE_DELIVERY_FAIL_WHITE,
                            ORDER_SYNC_ONLINE_DELIVERY_FAIL_BLACK,
                            PUSH_ORDER_FORBID_EDIT_AMOUNT,
                            PRINTER_INOUT_LIST_5000_WHITELIST,
                            AUTONOMY_SYNC_PLATFORM_CATE_WHITE,
                            SHOP_PUBLISH_WHITELIST,
                            CUSTOMER_CHAT_NEW_VERSION,
                            KS_SHELVES_SUPPORT_VIDEO,
                            FORCAST_CATEGORY_WITH_IMAGE,
                            USE_SYSTEM_FORCAST_CATEGORY,
                            ORDER_DRP_PRIORITY_FILTERRULE,
                            DRP_SUPPLIER_SYNC_STOCK_WHITELIST,
                            PRINTER_SENSITIVE_WHITELIST,
                            PRINTER_SUPPORT_SUB_BILL_WHITELIST,
                            PARTNER_SPU_SHOP_LINK_WHITE_LIST,
                            TAO_GOODS_SHELVES_TAO_PLATFORM,
                            DAREN_IMPROT_ERP_ORDER_TO_SAMPLE
                        ]
                    }
                )

                if (success) {
                    const temp = {
                        ...data,
                        AFTER_SALE_IPC_OPEN_V2: !data.AFTER_SALE_IPC_OPEN_V2,
                        ORDER_SYNC_ONLINE_DELIVERY_FAIL_WHITE_LIST:
                            data.ORDER_SYNC_ONLINE_DELIVERY_FAIL_WHITE && !data.ORDER_SYNC_ONLINE_DELIVERY_FAIL_BLACK
                    }

                    const currentUser = yield select(state => state.user?.currentUser)
                    const { isAgent } = currentUser || {}

                    // 处理用户在预发环境，重定向到正式
                    if (
                        !temp.ACCESS_PRE &&
                        !isAgent &&
                        window.PROJECT_CONFIG.sentryMode === 'pre' &&
                        window.top === window.self
                    ) {
                        window.location.href = window.location.href.replace('pre', '')
                    }

                    yield put({
                        type: 'update',
                        payload: {
                            userMenuWhiteList: temp,
                            userMenuWhiteListInited: true
                        }
                    })
                } else {
                    $message.error(message)
                }
            } catch (error) {
                console.error('REJECT_queryUserMenuWhiteList 获取白名单失败', error)
            }
        },
        *queryUserMenus(_, { call, put }) {
            let contractList = null

            // eslint-disable-next-line jst-gyl/disable-empty-catch
            try {
                const {
                    success: versionSuccess,
                    data: versionData,
                    message: versionMessage
                } = yield call(getContractVersion)
                if (versionSuccess) {
                    contractList = versionData?.contractList
                } else {
                    $message.error(versionMessage)
                }
            } catch (error) {
                console.error('REJECT_getContractVersion 获取用户版本失败', error)
            }
            const { success, message, data } = yield call(cacheRequestWrap(getUserMenus, 'getUserMenus'), {
                envType: PROJECT_CONFIG.sentryMode,
                appCode: fullAppCode,
                showArea: ['MENU_CATALOGUE'],
                contractList
            })

            if (success) {
                // 追查userMenus异常问题
                if (!Array.isArray(data)) {
                    captureMessage('userMenus异常', {
                        anchor: 'queryUserMenus',
                        extra: {
                            success,
                            message,
                            data: JSON.stringify(data),
                            timestamp: Date.now()
                        }
                    })
                }

                yield put({
                    type: 'update',
                    payload: {
                        userMenus: data
                    }
                })
            } else {
                $message.error(message)
            }
        },
        *fetchBlackMenuList(_, { call, put }) {
            // eslint-disable-next-line jst-gyl/disable-empty-catch
            try {
                const headers = isZongHengApp
                    ? {
                          domain: document.domain
                      }
                    : {}

                const { success, data, message } = yield call(
                    cacheRequestWrap(queryHidedMenuList, `queryHidedMenuList_isZongHengApp_${isZongHengApp}`),
                    null,
                    headers
                )
                if (success) {
                    yield put({ type: 'saveBlackMenuList', payload: transBlackList(data) })
                    return
                } else {
                    $message.error(message)
                    return null
                }
            } catch (e) {
                console.error('REJECT_获取菜单黑名单失败', e)
            }
        },
        *queryBindShop(_, { call, put }) {
            const params = {
                shopTypes: PLATFORM_INFO_LIST
            }
            try {
                const response = yield call(queryBindShopApi, { ...params })

                if (response) {
                    const { success, message, data } = response
                    if (success) {
                        yield put({
                            type: 'update',
                            payload: {
                                shopIdList: data
                            }
                        })
                    } else {
                        $message.error(message)
                    }
                }
            } catch (error) {
                console.error('REJECT_根据店铺类型获取店铺信息失败', error)
            }
        },
        *queryBindShopTotal({ payload }, { call, put }) {
            const includeShopSites = filterShopTypeListByPlatformType(PLATFORM_INFO_LIST)
            const params = {
                includeShopSites,
                sync: payload?.sync || false
            }
            // eslint-disable-next-line jst-gyl/disable-empty-catch
            try {
                const response = yield call(queryShopInfoTotal, { ...params })

                if (response) {
                    const { success, message, data } = response
                    if (success) {
                        yield put({
                            type: 'update',
                            payload: {
                                shopInfoTotal: data
                            }
                        })
                    } else {
                        $message.error(message)
                    }
                }
            } catch (error) {
                // 404 抛出 error 对象被外面的 try catch 拿到..
                console.error('REJECT_获取站点下店铺统计信息失败', error)
            }
        },
        *queryPlatformBanKeywords(_, { call, put }) {
            // eslint-disable-next-line jst-gyl/disable-empty-catch
            try {
                const response = yield call(queryPlatformBanKeywords, {})

                if (response) {
                    const { success, message, data } = response
                    if (success) {
                        yield put({
                            type: 'update',
                            payload: {
                                platformBanKeywords: (data || []).reduce((result, item) => {
                                    if (item.enable) {
                                        result[item.shopType] = {
                                            ...item,
                                            needCheckFiled: (item.needCheckFiled || []).reduce((result, item) => {
                                                result[item.filedType] = item.banKeywords
                                                return result
                                            }, {})
                                        }
                                    }
                                    return result
                                }, {})
                            }
                        })
                    } else {
                        $message.error(message)
                    }
                }
            } catch (error) {
                console.error('REJECT_getContractVersion 获取平台禁用的关键词失败', error)
            }
        },
        *query(_, { call, put }) {
            try {
                const response = yield call(cacheRequestWrap(getUserMenuPermission, 'getUserMenuPermission'))
                if (response) {
                    let { success, message, data } = response

                    if (success) {
                        yield put({
                            type: 'update',
                            payload: {
                                menus: data
                            }
                        })

                        return data
                    } else {
                        $message.error(message)
                        return []
                    }
                }
            } catch (error) {
                if (
                    !window.TERMINANAME_IS_SQMALL ||
                    !window.TERMINANAME_IS_DLZ ||
                    PROJECT_CONFIG.terminalName !== 'TOWER'
                ) {
                    console.error('REJECT_getUserMenuPermission 网络错误', error)

                    const reback = encodeURIComponent(window.location.href)
                    history.push(`/error?reback=${reback}`)
                }
            }
        },
        *updateShowMenuTip({ payload }, { put }) {
            yield put({
                type: 'update',
                payload: {
                    showMenuTip: payload
                }
            })
        }
    },
    reducers: {
        updateBigShopCoIdList(state, { payload }) {
            return {
                ...state,
                bigShopCoIdList: payload
            }
        },
        updateBigShopCoIdListFetching(state, { payload }) {
            return {
                ...state,
                updateBigShopCoIdListFetching: payload
            }
        },
        saveBlackMenuList(state, { payload }) {
            return {
                ...state,
                blackMenuListMounted: true,
                blackMenuList: payload
            }
        },
        update(state, { payload }) {
            return {
                ...state,
                ...payload
            }
        }
    }
}
